export default __webpack_public_path__ + "static/media/Tesso's Strife.aab69abf.jpg";